module.exports = __webpack_public_path__ + "img/Pill Bottle.9b5de53.png";